export default "__VITE_ASSET__DWNKWIRK__"